import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function Toast() {
  const [isVisible, setIsVisible] = useState(false);
  const [buyer, setBuyer] = useState({
    name: 'Carlos L.',
    city: 'Bogotá'
  });
  const buyers = [{
    name: 'Carlos L.',
    city: 'Bogotá'
  }, {
    name: 'María G.',
    city: 'Medellín'
  }, {
    name: 'Juan P.',
    city: 'Lima'
  }, {
    name: 'Ana M.',
    city: 'Santiago'
  }];
  useEffect(() => {
    // Initial delay before first toast
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    // Interval to cycle toasts
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
        setBuyer(randomBuyer);
        setIsVisible(true);
      }, 1000); // Wait 1s before showing next one
    }, 15000); // Show a new toast every 15 seconds
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-176">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-24 md:bottom-8 left-4 z-50 bg-white rounded-xl shadow-xl border border-slate-100 p-3 pr-6 flex items-center gap-3 max-w-sm" data-id="element-177">
          <div className="bg-green-100 text-green-600 w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-178">
            <CheckCircle2 className="w-5 h-5" data-id="element-179" />
          </div>
          <div data-id="element-180">
            <p className="text-sm font-bold text-slate-800" data-id="element-181">
              {buyer.name} de {buyer.city}
            </p>
            <p className="text-xs text-slate-500" data-id="element-182">
              compró el ebook · hace 1 minuto
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}